import { useEffect, useRef } from 'react';

// useHoistFocusVisibleClass is for when we need a focusVisible class on
//  a container component but MUI only has it available on the input

export var useHoistFocusVisibleClass = function useHoistFocusVisibleClass(_ref) {
  var focusVisibleClass = _ref.focusVisibleClass,
    classToHarvestFrom = _ref.classToHarvestFrom,
    classToApplyTo = _ref.classToApplyTo;
  var applyToRef = useRef(null);
  var harvestRef = useRef(null);

  // finds which element to watch for focusVisible and which element to put it on
  var collectInputRef = function collectInputRef(inputElem) {
    if (!inputElem) {
      return;
    }
    var anElem = inputElem;
    while (!(applyToRef.current && harvestRef.current)) {
      if (anElem && anElem.parentElement) {
        anElem = anElem.parentElement;
        if (anElem.classList.contains(classToHarvestFrom)) {
          harvestRef.current = anElem;
        }
        if (anElem.classList.contains(classToApplyTo)) {
          applyToRef.current = anElem;
        }
      }
    }
    if (applyToRef.current && harvestRef.current) {
      inputElem.onfocus = delayedUpdateOuterClassList;
      inputElem.onblur = delayedUpdateOuterClassList;
    }
  };
  var delayedUpdateOuterClassList = function delayedUpdateOuterClassList() {
    setTimeout(updateOuterClassList, 1);
  };

  // updateOuterClassList() moves the "focus-visible" class out to the container,
  //  to allow focus to be displayed around that component rather than the input
  var updateOuterClassList = function updateOuterClassList() {
    if (applyToRef.current && harvestRef.current) {
      if (harvestRef.current.classList.contains('Mui-focusVisible')) {
        applyToRef.current.classList.add(focusVisibleClass);
      } else {
        applyToRef.current.classList.remove(focusVisibleClass);
      }
    }
  };
  useEffect(updateOuterClassList);
  return {
    collectInputRef: collectInputRef
  };
};